import { clientConfigApi } from "./clientConfig";

export const { useGetClientConfigQuery } = clientConfigApi;
